import request from "./httpService";

const COMMUNICATION_ENDPOINT = '/communication';

const logOutbound = (data) => {
    return request({
        method: "POST",
        url: `${COMMUNICATION_ENDPOINT}/outbound`,
        data: data,
    });
};

const logInbound = (data) => {
    return request({
        method: "POST",
        url: `${COMMUNICATION_ENDPOINT}/inbound`,
        data: data,
    });
};

const getCustomerCommunications = (customerId, filters = {}, signal) => {
    return request({
        method: "GET",
        url: `${COMMUNICATION_ENDPOINT}/customer/${customerId}`,
        params: filters,
        signal: signal
    });
};

const getCustomerCommunicationStats = (customerId, options = {}, signal) => {
    return request({
        method: "GET",
        url: `${COMMUNICATION_ENDPOINT}/customer/${customerId}/stats`,
        params: options,
        signal: signal
    });
};

const updateStatus = (externalMessageId, data) => {
    return request({
        method: "PUT",
        url: `${COMMUNICATION_ENDPOINT}/status/${externalMessageId}`,
        data: data,
    });
};

export const CommunicationService = {
    logOutbound,
    logInbound,
    getCustomerCommunications,
    getCustomerCommunicationStats,
    updateStatus
};
